import { useGlobalStore } from '@/stores';
import { post } from '@/utils/Http';
import { showValidationMessage } from '@/utils/Notification';

/**
 * Perform HTTP post and return promise.
 *
 * @param {string}        target - The URL to post to.
 * @param {string|Object} params - The values to post. Either a URL encoded string or an object of parameters.
 * @param {string}        loading - Part of panel to display loading in.
 * @param {function}      onSuccess
 * @return Promise
 */
const loadMedia = (target, params, loading, onSuccess) => {
    const store = useGlobalStore();
    store.setMediaLoading(loading);
    const promise = post(target, params, onSuccess);
    promise.then((response) => {
        store.setMediaLoading(null);
        if (response.status !== 'OK') {
            showValidationMessage(response.errorMessage);
        }
    });

    return promise;
};

export default loadMedia;
